export default "__VITE_ASSET__CpsfLQy2__"